<script>
import PickupInfoDialog from "@/views/trips/view/components/dialogs/PickupInfoDialog.vue";
import { mapActions } from "pinia";
import { useSnackbarStore } from "@/store/snackbar.store.ts";

export default {
  name: "LoadAction",
  components: {
    PickupInfoDialog,
  },
  inheritAttrs: false,
  props: {
    trip: Object,
    route: Object,
    stop: Object,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["load"],
  data() {
    return {
      showDialog: false,
    };
  },
  methods: {
    ...mapActions(useSnackbarStore, ["showSnackbarError"]),
    showLoadVerification() {
      this.showDialog = true;
    },
    save() {
      this.$emit("load");
    },
  },
};
</script>

<template>
  <v-btn :disabled="disabled" block v-bind="$attrs" variant="flat" @click="showLoadVerification">
    Load and verify
  </v-btn>
  <pickup-info-dialog
    v-model="showDialog"
    :route="route"
    :stop="stop"
    :trip-id="trip.id"
    title="Verify information"
    @save="save"
  ></pickup-info-dialog>
</template>

<style lang="scss" scoped></style>
